import {currencyFormatter} from '@homeaway/hacommons-i18n';

import {MAX_PRICES} from './constants';

export const getLimitedMaxPrice = (
    currency = '',
    filterByTotalPrice = false,
    lengthOfStay = 0
) => {
    const maxLimitForOneNight =
        MAX_PRICES[currency.toUpperCase()] || MAX_PRICES.DEFAULT;

    if (filterByTotalPrice && lengthOfStay) {
        return maxLimitForOneNight * lengthOfStay;
    }

    return maxLimitForOneNight;
};

export const getLimitedMaxDisplayPrice = (
    maxAllowedPrice: number,
    maxPrice: number | null
) => {
    return maxPrice && Number.isInteger(maxPrice)
        ? Math.min(maxAllowedPrice, maxPrice)
        : maxAllowedPrice;
};

export function getFormattedCurrencyRange({
    minPrice,
    maxPrice,
    currency,
    locale,
    isMax,
}) {
    const minPriceFormatted = currencyFormatter.formatNumber({
        value: minPrice,
        currencyCode: currency,
        locale,
    });
    const maxPriceFormatted = currencyFormatter.formatNumber({
        value: maxPrice,
        currencyCode: currency,
        locale,
    });

    return `${minPriceFormatted} - ${maxPriceFormatted}${isMax ? '+' : ''}`;
}
